// profileSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileUpdated: false, 
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileDataUpdate: (state, action) => {
      state.profileUpdated = action.payload;
    },
  },
});

export const { setProfileDataUpdate } = profileSlice.actions;
export default profileSlice.reducer;
